import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthStore } from '../stores/auth.store';

export const homeGuard = (): UrlTree => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const club = authStore.club();
  return router.createUrlTree(club ? ['/transactions'] : ['/403']);
};
